module.exports = __webpack_public_path__ + "media/images/admin/icons/maximize-2-c0438627e69ed628835559d8076f56de.svg";